
















import { Component, Prop, Vue } from "vue-property-decorator";
import {AccomodationUnitStatusEnum} from "@/shared/models/enums.type";
import {AccomodationUnitStatus} from "@/shared/models/accomodationUnitStatus";
import {Getter} from "vuex-class";

@Component
export default class TableCellUnitTypeDisplay extends Vue {
  @Prop({ default: {} }) item: any;
  @Prop({ default: () => [] }) accomodationUnitStatuses!: AccomodationUnitStatus[];
  @Prop({ default: false }) renderStatus!: boolean;
  @Prop({ default: false }) lightenPropertyColor?: boolean;

  @Prop({ default: false }) noHighlightOnProperty?: boolean;
  
  @Getter("appParams/unitRenderTypeLineOne") renderTemplateTypeLineOne?: string;
  @Getter("appParams/unitRenderTypeLineTwo") renderTemplateTypeLineTwo?: string;
  
  get emphasizedLine()
  {
    if(this.renderTemplateTypeLineOne === "" && this.renderTemplateTypeLineTwo === "")
    {
      return this.item.propertyName;
    }

    return this.$t(this.renderTemplateTypeLineOne ?? "", this.renderProps);
  }
  
  get deEmphasizedLine()
  {
    if(this.renderTemplateTypeLineTwo === "" && this.renderTemplateTypeLineOne === "")
    {
      return this.item.accomodationUnitTypeName +
      (this.item.accomodationUnitName
          ? ", " + this.item.accomodationUnitName
          : "")
    }

    return this.$t(this.renderTemplateTypeLineTwo ?? "", this.renderProps);
  }
  
  get renderProps()
  {
    return {
      unitName: this.item.accomodationUnitName,
      unitTypeName: this.item.accomodationUnitTypeName,
      propertyName: this.item.propertyName
    }
  }
  
  unitStatus(value: number){
    //status = 1 -> "Ready" - unnecessary to show every time
    if (value !== AccomodationUnitStatusEnum.Clean){
      const toReturn = this.accomodationUnitStatuses?.find(x => x.id == value);
      return toReturn?.textResourceKey;
    }
    return;
  }
  
}
